import React from 'react';
import { Stack, TextField } from '@mui/material';
import { QrPreview } from './qr-preview';
import { reviewLandingField } from '../styles';

interface QrSectionProps {
  logoUrl?: string;
  target: string;
  reviewLandingMessage: string;
  onReviewLandingChange: (value: string) => void;
  labels: {
    qrDownload: string;
    qrAlt?: string;
    reviewLandingLabel: string;
    reviewLandingPlaceholder: string;
  };
}

const QrSection: React.FC<QrSectionProps> = ({
  logoUrl,
  target,
  reviewLandingMessage,
  onReviewLandingChange,
  labels,
}) => (
  <Stack spacing={2}>
    <QrPreview
      logoUrl={logoUrl}
      target={target}
      downloadLabel={labels.qrDownload}
      altLabel={labels.qrAlt || 'Business review QR code'}
    />
    <TextField
      sx={reviewLandingField}
      label={labels.reviewLandingLabel}
      placeholder={labels.reviewLandingPlaceholder}
      value={reviewLandingMessage}
      onChange={e => onReviewLandingChange(e.target.value)}
    />
  </Stack>
);

export { QrSection };
